export function projectEpisodePath(projectId: string, episodeId: string, hash = ''): string {
  return `/projects/${encodeURIComponent(projectId)}/episodes/${encodeURIComponent(episodeId)}${hash}`;
}

export function legacyEpisodePath(episodeId: string, hash = ''): string {
  return `/episodes/${encodeURIComponent(episodeId)}${hash}`;
}
